<section id="IcerikContainer">
    <div class="dev-wrapper dev-entrant-home dev-wrapper-entry-home dev-flex-container IcerikSubContainer">
        <article id="content" class="dev-flex-child">
            <div class="wizard-v4-content">
                <div class="wizard-form">
                    <div class="wizard-header">
                        <h3 class="heading">Başvuru Güncelleme</h3>
                        <!-- <p>Formu doldurup bir sonraki adıma geçiniz, veya istediğiniz adıma geçebilirsiniz.</p> -->
                    </div>
                    <div class="form-register" action="#" method="post" *ngIf="Yuklendi === true && PageData.Adim11Durum === 0">
                        <div id="form-total" role="application" class="wizard clearfix">
                            <div class="steps clearfix">
                                <ul role="tablist">
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(1)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">1</span>
                                                <span class="step-text">Kategori Seçimi</span>
                                                <span class="badge" *ngIf="PageData.Adim1Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(2)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">2</span>
                                                <span class="step-text">Künye</span>
                                                <span class="badge" *ngIf="PageData.Adim2Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(3)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">3</span>
                                                <span class="step-text">Özet</span>
                                                <span class="badge" *ngIf="PageData.Adim3Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(4)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">4</span>
                                                <span class="step-text">Hedef</span>
                                                <span class="badge" *ngIf="PageData.Adim4Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(5)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">5</span>
                                                <span class="step-text">Fikir</span>
                                                <span class="badge" *ngIf="PageData.Adim5Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(6)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">6</span>
                                                <span class="step-text">Uygulama</span>
                                                <span class="badge" *ngIf="PageData.Adim6Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(7)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">7</span>
                                                <span class="step-text">Sonuç</span>
                                                <span class="badge" *ngIf="PageData.Adim7Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(8)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">8</span>
                                                <span class="step-text">Dosya Yükleme</span>
                                                <span class="badge" *ngIf="PageData.Adim8Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(9)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">9</span>
                                                <span class="step-text">Sayfa Sayısı Doğrulama</span>
                                                <span class="badge" *ngIf="PageData.Adim9Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a (click)="AdimDegistir(10)">
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right renkli"></span>
                                                <span class="step-icon">10</span>
                                                <span class="step-text">İzinler Belgesi</span>
                                                <span class="badge" *ngIf="PageData.Adim10Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                    <li role="tab" class="done">
                                        <a>
                                            <div class="title">
                                                <span class="step-cizgi-left renkli"></span>
                                                <span class="step-cizgi-right"></span>
                                                <span class="step-icon">11</span>
                                                <span class="step-text">Başvur</span>
                                                <span class="badge" *ngIf="PageData.Adim11Durum === 0">!</span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="content clearfix">
                                <form class="form form-horizontal AdimliForm" novalidate="">
                                    <p *ngIf="GlobalYonetim.Adim11.Header.length > 0" [innerHtml]="GlobalYonetim.Adim11.Header" style="max-width: none; width: 100%; margin-bottom: 10px"></p>

                                    <!-- <div style="background-color: white; float: left; padding-left:0px; width: 80px;">
                                        <div class="form-check" (click)="RokIzinChanged()">
                                            <i class="far fa-check-circle" style="margin-right: 10px; font-size: 14px; color: green;" *ngIf="PageData.Rok == true"></i>
                                            <i class="far fa-circle" style="margin-right: 10px; font-size: 14px;" *ngIf="PageData.Rok == false"></i>
                                            <label class="form-check-label CheckboxTitle">
                                                Evet
                                            </label>
                                        </div>
                                    </div> -->

                                    <p class="kirmizi" *ngIf="PageData.Adim1Durum === 0 || PageData.Adim2Durum === 0 || PageData.Adim3Durum === 0 || PageData.Adim4Durum === 0 || PageData.Adim5Durum === 0 || PageData.Adim6Durum === 0 || PageData.Adim7Durum === 0 || PageData.Adim8Durum === 0 || PageData.Adim9Durum === 0 || PageData.Adim10Durum === 0">
                                        Başvuruyu gönderebilmek için bütün adımları tamamlamalısınız.
                                    </p>
                                    <button *ngIf="PageData.Adim1Durum === 1 && PageData.Adim2Durum === 1 && PageData.Adim3Durum === 1 && PageData.Adim4Durum === 1 && PageData.Adim5Durum === 1 && PageData.Adim6Durum === 1 && PageData.Adim7Durum === 1 && PageData.Adim8Durum === 1 && PageData.Adim9Durum === 1 && PageData.Adim10Durum === 1"
                                        class="EkleButton" [swal]="DosyaSilSwal" (confirm)="BasvuruGonder()" (deny)="OdemeSayfasiAc()">Başvuruyu Gönder</button>
                                    <!-- <button 
                                        class="EkleButton" [swal]="DosyaSilSwal" (confirm)="BasvuruGonder()">Başvuruyu Gönder</button> -->

                                </form>
                            </div>
                            <div class="actions clearfix">
                                <ul role="menu" class="Pagination">
                                    <li (click)="AdimDegistir(10)" class="BirOnceki"><a role="menuitem">Bir Önceki Adım</a></li>
                                    <!-- <li (click)="AdimDegistir(10)"><a role="menuitem">Bir Sonraki Adım</a></li> -->
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </article>
    </div>

</section>